import * as ActionTypes from "../ActionTypes";


export const GetEarningAction = (params) => {
    return {
        type: ActionTypes.PAYROLL_EARNING_GET_REQUEST,
        params
    }
}
export const GetDeductionAction = (params) => {
    return {
        type: ActionTypes.PAYROLL_DEDUCTION_GET_REQUEST,
        params
    }
}

export const GetCustomEarningAction = (params) => {
    return {
        type: ActionTypes.PAYROLL_CUSTOM_EARNING_GET_REQUEST,
        params
    }
}
export const GetCustomDeductionAction = (params) => {
    return {
        type: ActionTypes.PAYROLL_CUSTOM_DEDUCTION_GET_REQUEST,
        params
    }
}

